import React from "react"

import Grid from "@material-ui/core/Grid"
import TFSLogo from "../images/FinalsScoreFS.png"
import Typography from "@material-ui/core/Typography"
import Divider from "@material-ui/core/Divider"
import { Bar, Pie } from "react-chartjs-2"
import { Button, Container } from "@material-ui/core"
import { Link } from "gatsby"

const IndexPage = () => {
  return (
    <Container>
      <Grid container justify="center" alignContent="center">
        <Grid item sm={4}>
          <Typography
            variant="h4"
            style={{
              textAlign: "center",
              marginBottom: ".5em",
              fontStyle: "italic",
              fontWeight: "bold",
            }}
          >
            Welcome to
          </Typography>
          <img src={TFSLogo} alt="The final scores" />
        </Grid>
      </Grid>

      <Grid
        container
        justify="center"
        alignContent="center"
        style={{ marginBottom: "3em" }}
      >
        <Grid item sm={10}>
          <Typography
            variant="h5"
            style={{
              textAlign: "center",
              marginBottom: ".5em",
              fontStyle: "italic",
              fontWeight: "bold",
            }}
          >
            Your home for Weekly NFL predictions and expert insights
          </Typography>
        </Grid>
        <Grid item sm={10}>
          <Button
            size="large"
            style={{
              marginTop: "2em",
            }}
            fullWidth
          >
            <Link
              to="/register"
              style={{
                color: `var(--green)`,
                textDecoration: `none`,
                marginTop: "5px",
              }}
            >
              Register for your free account!
            </Link>
          </Button>
        </Grid>
      </Grid>
      <Divider variant="inset" />
      <Grid
        container
        justify="center"
        alignContent="center"
        alignItems="center"
        spacing={3}
        style={{ marginTop: "3em", marginBottom: "3em" }}
      >
        <Grid item sm={10}>
          <Typography
            variant="h4"
            style={{
              textAlign: "center",
              marginBottom: ".5em",
              fontStyle: "italic",
              fontWeight: "bold",
            }}
          >
            How does it work?
          </Typography>
          <Typography
            variant="h6"
            style={{
              textAlign: "center",
              marginBottom: ".5em",
              fontStyle: "italic",
              fontWeight: "bold",
            }}
          >
            TheFinalScores.com uses our own proprietary Machine Learning
            algorithm to analyze past and present team and player statistics to
            evaluate and predict game winners and scores!
          </Typography>
        </Grid>
      </Grid>
      <Divider variant="inset" />
      <Grid
        container
        justify="center"
        alignContent="center"
        alignItems="center"
        spacing={3}
        style={{ marginTop: "3em", marginBottom: "3em" }}
      >
        <Grid item xs={12}>
          <Typography
            variant="h4"
            style={{
              textAlign: "center",
              marginBottom: ".5em",
              fontStyle: "italic",
              fontWeight: "bold",
            }}
          >
            Percent of Winning Wagers
          </Typography>
        </Grid>
        <Grid item xs={10} sm={6}>
          <Pie
            data={{
              labels: ["Wagers Won", "Wagers Lost"],
              datasets: [
                {
                  data: [52.38, 47.62],
                  backgroundColor: ["green", "red"],
                },
              ],
            }}
            options={{
              title: {
                display: true,
                text: "To break even in Vegas",
              },
              legend: {
                display: true,
              },
            }}
          />
        </Grid>
        <Grid item xs={10} sm={6}>
          <Pie
            data={{
              labels: ["Wagers Won", "Wagers Lost"],
              datasets: [
                {
                  data: [62.92, 37.08],
                  backgroundColor: ["green", "red"],
                },
              ],
            }}
            options={{
              title: {
                display: true,
                text: "THEFINALSCORES four star picks!",
              },
              legend: {
                display: true,
              },
            }}
          />
        </Grid>
      </Grid>
      <Divider variant="inset" />
      <Grid
        container
        justify="center"
        alignItems="center"
        spacing={3}
        style={{ marginTop: "2em", marginBottom: "2em" }}
      >
        <Grid item sm={12} style={{ marginTop: "3em", marginBottom: "3em" }}>
          <Typography
            variant="h4"
            style={{
              textAlign: "center",
              marginBottom: ".5em",
              fontStyle: "italic",
              fontWeight: "bold",
            }}
          >
            Our winning track record by the numbers
          </Typography>
        </Grid>
        <Grid item md={6} xs={12}>
          <Bar
            data={{
              labels: [
                "2004",
                "2005",
                "2006",
                "2007",
                "2008",
                "2009",
                "2010",
                "2011",
                "2012",
                "2013",
                "2014",
                "2015",
                "2016",
                "2017",
                "2018",
                "2019",
              ],
              datasets: [
                {
                  label: "Annual Profits",
                  backgroundColor: "#146633",
                  data: [
                    5150,
                    4990,
                    6060,
                    4160,
                    4260,
                    3730,
                    3790,
                    6000,
                    5410,
                    5600,
                    6850,
                    3900,
                    2930,
                    2790,
                    2700,
                    7470,
                  ],
                },
              ],
            }}
            options={{
              title: {
                display: true,
                text: "TheFinalScores.com Annual Profits",
              },
              legend: {
                display: false,
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      callback: (value, index, values) => {
                        return value.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })
                      },
                    },
                  },
                ],
              },
            }}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography variant="h6">
            Use our proven system to your advantage! For the last 16 years, our
            proven system has warranted these profits year after year. With a
            $100 base bettor and using our 1 to 4-star system, here is a
            breakdown of our earnings every year!
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        justify="center"
        alignItems="center"
        spacing={3}
        style={{ marginTop: "2em", marginBottom: "2em" }}
      >
        <Grid item md={6} xs={12}>
          <Typography style={{ textAlign: "right" }} variant="h6">
            Returns greater than the US stock market! Starting with an initial
            bankroll of $10,000, thefinalscores.com proprietary machine learning
            algorithm and our methodical approach to educated wagering warranted
            a 857.9% return over a 16 year period.
          </Typography>
        </Grid>
        <Grid item md={6} xs={12}>
          <Bar
            data={{
              labels: [
                "2004",
                "2005",
                "2006",
                "2007",
                "2008",
                "2009",
                "2010",
                "2011",
                "2012",
                "2013",
                "2014",
                "2015",
                "2016",
                "2017",
                "2018",
                "2019",
              ],
              datasets: [
                {
                  label: "Bank Roll",
                  backgroundColor: "#146633",
                  data: [
                    15149,
                    20137,
                    26195,
                    30353,
                    34612,
                    38344,
                    42129,
                    48122,
                    53531,
                    59134,
                    65981,
                    69885,
                    72818,
                    75605,
                    78300,
                    85765,
                  ],
                },
              ],
            }}
            options={{
              title: {
                display: true,
                text: "TheFinalScores.com Cumulative Bank Roll",
              },
              legend: {
                display: false,
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      callback: (value, index, values) => {
                        return value.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })
                      },
                    },
                  },
                ],
              },
            }}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export default IndexPage
